import { render } from "./HeroAgenda.vue?vue&type=template&id=198fee27&scoped=true&ts=true"
import script from "./HeroAgenda.ts?vue&type=script&lang=ts"
export * from "./HeroAgenda.ts?vue&type=script&lang=ts"

import "./HeroAgenda.scss?vue&type=style&index=0&id=198fee27&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198fee27"]])

export default __exports__